<script lang="tsx" setup>
import { defineExpose, ref } from 'vue'
import { useInitDefaultConfig } from './helper'
import type { TOptions } from './types'

const visible = ref(false)
const closeModal = () => {
  visible.value = false
}
const handleConfirm = () => {
  config.value.onConfirm?.(() => {
    visible.value = false
  })
}
const loading = ref(false)
const config = ref<TOptions>({})
const { initDefaultConfig } = useInitDefaultConfig()

const handleOpen = (option: TOptions) => {
  const { closeOnClickModal = false } = option
  config.value = {
    closeOnClickModal,
    ...initDefaultConfig({
      closeModal,
      handleConfirm,
      loading,
      showCancelButton: option.showCancelButton,
      showConfirmButton: option.showConfirmButton,
      cancelDisabled: option.cancelDisabled,
      confirmDisabled: option.confirmDisabled,
      confirmText: option.confirmText,
    }),
    ...option,
  }
  visible.value = true
}

const handleClose = () => {
  visible.value = false
}
const onClosed = () => {
  config.value = {}
}

defineExpose({
  handleOpen,
  handleClose,
})
</script>

<template>
  <el-dialog
    v-model="visible"
    class="dialog-of-ui"
    :close-on-click-modal="config.closeOnClickModal"
    :width="config.width"
    @close="config.onClose"
    @closed="onClosed"
  >
    <template #header>
      <component v-if="config.header" :is="config.header" />
      <slot v-else name="header"></slot>
    </template>
    <template #default>
      <component v-if="config.body" :is="config.body" />
      <slot v-else name="default"></slot>
    </template>
    <template #footer>
      <component v-if="config.footer" :is="config.footer" />
      <slot v-else name="footer"></slot>
    </template>
  </el-dialog>
</template>
<style lang="scss">
.dialog-of-ui {
  padding: 24px 40px 40px 40px;
  .el-dialog__header {
    font-size: 18px;
    font-weight: bold;
  }
}
</style>
